import React, {Component} from 'react';
import { toast } from 'react-toastify';
import DragSortableList from 'react-drag-sortable'
import { Loading, Notification } from 'carbon-components-react';
import FileUploader from 'carbon-components-react/lib/components/FileUploader';
import { Breadcrumb} from '../../../components';
import { insertDmService, deleteDmService, getDmService } from '../../../services/Api';
import appConfig from '../../../config/app-config';

class BannersDashboard extends Component{
  constructor(props){
    super(props)
    this.state = {
      loadUpload: false,
    }
  }

  componentWillMount = async () => {
    await this.load();
  }

  load = async() => {
    try {
      const banners = await getDmService('/Banner') || [];
      this.setState({banners});
    } catch (error) {
      console.error(error);
    }
  }

  publicar = async() => {
    const {banners} = this.state;
    try {
      await insertDmService('/Banner', {banners});
      
      toast.success("Banners publicados");
    } catch (e) {
      this.errorHandler(e);
    }
  }
  
  deleteImage = async(id) => {
    try {
      await deleteDmService('/Banner/', id);
      toast.success("Itens excluídos com sucesso");
      this.load();
    } catch (e) {
      this.errorHandler(e);
    }
  }

  fileChange = async (e, name) => {
    console.log("fileChange", e);
    const { match } = this.props;
    const { files } = document.getElementsByName(name)[0];
    if (files.length > 0) {
      const _files = [];
      for (let i = 0; i < files.length; i++) _files.push(files[i]);

      await this.uploadFileArray(_files, match.params.id);
      setTimeout(async () => {
        await this.load();
      }, 750);
      this.fileUploader.clearFiles();
    }
  };

  uploadFileArray = async (files) => {
    const {banners} = this.state;
    files.map(async file => {
      try {
        const data = new FormData();
        data.append('file', file);
        console.log("uploadFileArray", file)
        if(file.size >= 200000001){
          toast.warn("O tamanho do arquivo excede o permitido");
        }else{
          this.setState({loadUpload: true});
          const banner = await insertDmService(`/Banner/Upload`, data);
          await this.setState({loadUpload: false, banners: [...banners, banner]});
        }
        

      } catch (err) {
        this.setState({loadUpload: false});
        toast.error(err.message);
      }
    });
  };
  
  errorHandler = err => {
    if (err.error && typeof err.error.response.data.modelState !== 'undefined') {
      let error = 'Ocorreu o seguinte erro: ';

      const erros = err.error.response.data.modelState;
      for (const p in erros) {
        let name = p.replace('model.', '');
        name = name[0].toUpperCase() + name.slice(1);
        error += `${erros[p]}; `;
      }
      toast.warning(error.trim());
    } if(err.message) 
      toast.error(err.message);
    else {
      toast.error('Ocorreu um erro ao salvar os dados, tente novamente mais tarde');
    }
  };

  onChangeText = (event) => {
    const { target } = event;
    this.setState({
      [target.id]: target.value
    });
  }

  onSort = (sortedList) => {
    const {banners} =this.state;
    console.log("sortedList", sortedList, banners)
    if(banners) {
      sortedList.forEach((item, idx) => {
        banners.find(p=>p.id === item.ownId).ordem = idx
      })
    }
  }

  getList = () => {
    const {banners} = this.state;
    return !banners ? [] : banners.map(item => {return {ownId:item.id, content: (
      <div className="art-preview-item bx--col-md-3" key={`i${item.id}`} style={{opacity:item.ativo ? 1 : 0.3}}>
        <img src={appConfig.IMAGE_PATH + item.imagem} alt="" />
        <div className="img-action">
          <i className="pointer trash-size material-icons" onClick={() => this.deleteImage(item.id)}>
            remove_circle
          </i>
        </div>
      </div>
    )}})
  
  }

  render() {
    const {banners, loadUpload} = this.state;
    return(
      <div className="">
        {loadUpload && (
          <div className="loading-upload">
            <Loading withOverlay className="some-class" />
          </div>
        )}
        <Breadcrumb
          title="Banners Dashboard"
          description={(
            <div>
              Gerenciamento de banners
            </div>
          )}
          renderRight={(
            <div className="criacao-upload">
              <FileUploader
                className="upload-sem-p"
                buttonLabel="Upload de imagens"
                filenameStatus="edit"
                onChange={async e => {
                  await this.fileChange(e, 'imagens');
                }}
                buttonKind="secondary"
                multiple
                ref={fileUploader => (this.fileUploader = fileUploader)}
                accept={['.gif', '.jpeg', '.jpg', '.png']}
                name="imagens"
              />
              <button
                className="bx--btn btn-secondary-color h-sm-margin"
                type="button"
                onClick={() => this.publicar()}
              >
                  Publicar
              </button>
            </div>
          )}
        />
        <div className="content-wrapper">
          <div className="bx--row">
            <div className="bx--col-xs-12">
              <Notification
                kind="info"
                title="Extensões permitidas: "
                subtitle=".gif, .jpeg, .png"
              />
            </div>
          </div>
        </div>
        <div className="content-wrapper">
          {banners && banners.length === 0 && (
            <p>Sem imagens até o momento</p>
          )}
          <div className="art-preview bx--row">
            <DragSortableList items={this.getList()} onSort={this.onSort} type="horizontal" />
          </div>
        </div>
      </div>
    )
  }
}

export default BannersDashboard;



// WEBPACK FOOTER //
// ./src/screens/admin/Dashboard/BannersDashboard.js